import React from 'react';

const Body = () => (
    <>
        <div className="aboutTopPad"></div>
        <h2>Global Expansion</h2>
        The Group’s principal JD fascia has been widely recognised for a number of years as the leading retailer of
        branded and private label sports fashion apparel and footwear in the UK and Ireland. Increasingly, the JD fascia
        is attracting a similar reputation internationally where we now have more than 850 stores across 19 countries
        with JD Group fascias scheduled to open in Canada and New Zealand later in 2021.
        <br />
        <br />
        <strong>Europe</strong>
        <br />
        <br />
        Our previously stated ambition of opening one store on average per week across Europe was impacted by the
        COVID-19 outbreak but, despite this, JD has achieved further expansion this year with a net increase of 31
        stores across its existing territories. We would anticipate regaining our previous development momentum in 2021.
        <br />
        <br />
        <strong>North America</strong>
        <br />
        <br />
        The development of JD in the United States has also continued to gain momentum with a further 37 stores
        converted from Finish Line to JD in the year complemented by the opening of the JD Times Square flagship store
        in the second half of the year. Notwithstanding the operational restrictions caused by COVID-19, it remains our
        intention to convert a further 50 stores to JD in the year to January 2022.
        <br />
        <br />
        Further afield, the acquisition of Onepointfive Ventures Limited in Canada will provide the platform to develop
        JD Group fascias in Canada where we anticipate opening our first store in the second half of 2021.
        <br />
        <br />
        <strong>Asia Pacific</strong>
        <br />
        <br />
        There has been further expansion in Australia with an additional six stores opening in the year.
        <br />
        <br />
        Extending the global reach of our JD fascia is viewed positively by the international brands, both existing and
        new, and we look to leverage that positive regard for our proposition by negotiating enhanced access to new and
        often exclusive products, further increasing the differentiation in our offer.
        <h2>Market Position</h2>
        We ensure that the JD retail fascia retains its dynamic appeal and forges a deep connection with its consumers
        through the continual investment in our physical store portfolio, digital platforms and creative marketing. We
        continually look to further elevate the market position of the JD fascia and enhance the experience for the
        customer through the constant nurturing of global branded supplier relationships, existing and new, which we can
        develop and exploit to ensure our overall product range remains both authentic and uniquely appealing with our
        stores being highly differentiated destinations.
        <br />
        <br />
        Our core business strength is branded sports fashion and outdoor retail presented in an omnichannel environment.
        Where we use private labels, we will seek to present them as complementary to third party brands giving us
        additional options in ranging and price architecture. We seek to build very strong market positions and we look
        to maintain these through a continuous and intensely analytical approach to understanding business performance.
        We update our brand line up regularly, endeavouring to be the partner of choice to as many brands as possible
        with as much exclusive product as possible. The Board considers that continuing supply from Nike and adidas,
        being the main suppliers of third party branded sporting products, to the Group’s core sports fashion retail
        operation is essential to the business of the Group.
        <br />
        <br />
        We look to protect profitability by maintaining a rigorous analytical approach to managing product rate of sale
        and minimising markdown. Whilst we will promote product where appropriate, we aim to avoid short-term reactive
        discounting unnecessarily when our proposition is well differentiated.
        <h2>Store Portfolio</h2>
        We are engaged in omnichannel retail with the retail estate being essential to brand and product awareness, the
        customers’ overall digital experience and our ability to provide multiple delivery points. We believe that the
        combination of a largely exclusive product offering, presented in a well fitted store with world class standards
        of retail theatre, are major drivers of footfall to our stores.
        <br />
        <br />
        Stores give a platform to showcase product, provide consumers with the opportunity to physically see and try the
        product, and give us the operational flexibility and agility to offer an enhanced speed of service for online
        orders. We will continue to invest in property with a focus on the international expansion of the JD fascia.
        <br />
        <br />
        Considerable time and financial resources are invested in expanding and refurbishing our retail property
        portfolio although we continue to work with landlords on ensuring that our portfolio of leases has the maximum
        flexibility and the lowest committed cost possible.
        <h2>Multichannel</h2>
        The continuing international growth in physical store space is complemented by ongoing investment in our
        international multichannel capability through a significant multicurrency and multilanguage website estate. We
        utilise our digital platforms to maximise our reach and impact to consumers at a domestic and international
        level with consumers able to shop seamlessly across all channels. We believe this multichannel capability is a
        key differentiator for our business.
        <br />
        <br />
        Our digital and social media channels are important destinations for our customers with in-store digital devices
        (kiosk, web till and iPad) also giving customers additional options to purchase in store as they enable access
        to the full product range on the website and the full inventory held in the warehouse. Our multichannel
        capabilities also now include the ‘Pick from Store’ option giving customers access to the full stock listing
        regardless of location.
        <h2>Brexit</h2>
        The transition period ended during the financial year on 31 December 2020. The key direct and indirect risks
        associated with the range of outcomes at the end of the transition period along with the mitigating activities
        that have been, or will be implemented, by the Group are detailed in the{' '}
        <a className="link" href="https://files.jdplc.com/pdf/reports/annual-report-2021.pdf" title="Annual Report">
            Annual Report
        </a>
        .<h2>Investment in New Businesses</h2>
        Any new business which we invest in will have relevance to our core strength and all businesses in the Group
        need to be capable of enhanced profitability in the medium term. Our ultimate objective is to deliver long term
        sustainable earnings growth to enhance Total Shareholder Returns (‘TSR’) through share price performance and
        dividends, whilst retaining our financial capability to invest in the growth and the sustainability of our
        propositions.
        <h2>Environmental, Social and Governance (ESG) Strategy</h2>
        Subsequent to the Group’s FTSE 100 entry, we have made further commitments to improve our sustainability and
        environmental performance by establishing an ESG Committee. The Committee determines our future ESG strategy and
        monitors adherence to our existing documented Sustainability and ESG standard. Progress and updates from the ESG
        committee are communicated to the Board at scheduled Group board meetings by our Chief Financial Officer.
        <br />
        <br />
        This allows our ESG plans and strategy to be reviewed and scrutinised by a wider audience of Directors, the
        majority of whom hold multiple Non-Executive Director positions with other organisations, thus allowing our
        Chief Financial Officer and ESG Committee access to wider experience, feedback and comparative environmental
        performance information.
        <br />
        <br />
        The actual and potential ESG-related risks faced by our business (including use of Climate-change scenario
        analysis) have been detailed further in the{' '}
        <a className="link" href="https://files.jdplc.com/pdf/reports/annual-report-2021.pdf" title="Annual Report">
            Annual Report
        </a>{' '}
        .
        <br />
        <br />
        Further information on how the JD Group assists the community through its registered charity, The JD Foundation,
        can be found on “
        <a className="link" href="/jd-foundation" title="The JD Foundation">
            The JD Foundation
        </a>
        ” section on this website.
    </>
);

export const content = {
    image: 'https://files.jdplc.com/images/about/our-strategy.jpg',
    body: Body,
};
